import { Modal, TextInput } from '@wajeez-web/components/ui';
import React, { useState, useEffect } from 'react';
import { CommonModalProps } from './Types';
export interface TemplateCategoryData {
  title: string;
}

const TemplateCategoryModal: React.FC<
  CommonModalProps<TemplateCategoryData>
> = ({ onClose, onSubmit, isOpen, data }) => {
  const [values, setValues] = useState<TemplateCategoryData>({ title: '' });

  useEffect(() => {
    if (data) {
      data && setValues(data);
    }
  }, [data]);

  return (
    <Modal
      title={'Create Template Category'}
      open={isOpen}
      onSubmit={() => {
        onSubmit && onSubmit(values);
      }}
      onClose={onClose}
    >
      <TextInput
        label="Title"
        name="title"
        value={values.title}
        onChange={(name, value) => {
          setValues({ title: value });
        }}
        required={true}
      />
    </Modal>
  );
};

export default TemplateCategoryModal;
